import React, { useCallback, useContext, useState, useEffect } from "react";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  InputGroup,
  Dropdown,
  Spinner,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faSearch,
  faEraser,
  faFilter,
} from "@fortawesome/free-solid-svg-icons";
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { useCookies } from "react-cookie";
import { Context } from "../Search";
import { getAllChannel } from "../../../../controller/api/__classic__/channel";
import { includesSearchText } from "../../../../helper/text";

  const _FilterForm = () => {
  const { state, dispatch } = useContext(Context);

  const [cartId, setCartId] = useState(state.filter.cartId || "");
  const [numbers, setNumbers] = useState(state.filter.numbers || "");
  const [status, setStatus] = useState(state.filter.status ?? "");
  const [fromDate, setFromDate] = useState(state.filter.fromDate || null);
  const [toDate, setToDate] = useState(state.filter.toDate || null);
  const [playerPhone, setPlayerPhone] = useState(
    state.filter.playerPhone || "",
  );
  const [playerName, setPlayerName] = useState(state.filter.playerName || "");
  const [region, setRegion] = useState(state.filter.region || "");
  const [ticketId, setTicketId] = useState(state.filter.ticketId || "");
  const [channelId, setChannelId] = useState(state.filter.channelId || "");
  const [channels, setChannels] = useState([]);
  const [channelSearch, setChannelSearch] = useState("");
  const [cookies] = useCookies(["lottmekong"]);

  // Disable other filters when searching by cartId (order code)
  const isSearchingByCartId = cartId.trim().length > 0;

  useEffect(() => {
    setCartId(state.filter.cartId || "");
  }, [state.filter.cartId]);

  useEffect(() => {
    const fetchChannels = async () => {
      setChannelId("");
      const r = region || "MN";
      const response = await getAllChannel(cookies.lottmekong, r);
      if (response && response.data) {
        setChannels(response.data);
      } else {
        setChannels([]);
      }
    };
    fetchChannels();
  }, [region, cookies.lottmekong]);

  const filteredChannels = channelSearch
    ? channels.filter((channel) =>
        includesSearchText(channel.name, channelSearch),
      )
    : channels;

  const _submitForm = useCallback(() => {
    dispatch({
      type: "SUBMIT_FILTER",
      payload: {
        cartId: cartId.trim(),
        numbers: numbers.trim(),
        status: status,
        fromDate: fromDate,
        toDate: toDate,
        playerPhone: playerPhone.trim(),
        playerName: playerName.trim(),
        region: region,
        ticketId: ticketId.trim(),
        channelId: channelId,
      },
    });
  }, [
    dispatch,
    cartId,
    numbers,
    status,
    fromDate,
    toDate,
    playerPhone,
    playerName,
    region,
    ticketId,
    channelId,
  ]);

  const _resetForm = useCallback(() => {
    setCartId("");
    setNumbers("");
    setStatus("");
    setFromDate(null);
    setToDate(null);
    setPlayerPhone("");
    setPlayerName("");
    setRegion("");
    setTicketId("");
    setChannelId("");
    setChannelSearch("");
    dispatch({
      type: "RESET_FILTER",
    });
  }, [dispatch]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      _submitForm();
    }
  };

  return (
    <Card border="light" className="shadow-sm border-0 mb-3">
      <Card.Body className="p-3">
        <div className="d-flex align-items-center mb-3">
          <div className="icon icon-shape icon-sm shadow-sm border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
            <FontAwesomeIcon icon={faFilter} className="text-primary" />
          </div>
          <h6 className="mb-0">Tra cứu đơn hàng</h6>
        </div>

        <Row className="g-3 align-items-end">
          <Col xs={12} md={6} xl={2}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Mã đơn</Form.Label>
            <Form.Control
              type="text"
              placeholder="VD: KTxxx"
              value={cartId}
              onChange={(e) => setCartId(e.target.value)}
              onKeyPress={handleKeyPress}
              className="bg-white"
            />
          </Col>

          <Col xs={12} md={6} xl={2}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Mã vé</Form.Label>
            <Form.Control
              type="text"
              placeholder="Nhập mã vé"
              value={ticketId}
              onChange={(e) => setTicketId(e.target.value)}
              onKeyPress={handleKeyPress}
              className="bg-white"
              disabled={isSearchingByCartId}
            />
          </Col>

          <Col xs={12} md={6} xl={2}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Dãy số</Form.Label>
            <Form.Control
              type="text"
              placeholder="VD: 123456"
              value={numbers}
              onChange={(e) => setNumbers(e.target.value)}
              onKeyPress={handleKeyPress}
              className="bg-white"
              disabled={isSearchingByCartId}
            />
          </Col>

          <Col xs={12} md={6} xl={2}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Trạng thái</Form.Label>
            <Form.Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="bg-white"
              disabled={isSearchingByCartId}
            >
              <option value="">Tất cả</option>
              <option value="0">Đơn mới</option>
              <option value="1">Hoàn thành</option>
            </Form.Select>
          </Col>

          <Col xs={12} md={6} xl={2}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Miền</Form.Label>
            <Form.Select
              value={region}
              onChange={(e) => setRegion(e.target.value)}
              className="bg-white"
              disabled={isSearchingByCartId}
            >
              <option value="">Tất cả</option>
              <option value="MN">Miền Nam</option>
              <option value="MT">Miền Trung</option>
              <option value="MB">Miền Bắc</option>
            </Form.Select>
          </Col>

          <Col xs={12} md={6} xl={2}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Đài</Form.Label>
            <Dropdown className="w-100">
              <Dropdown.Toggle
                variant="white"
                className="w-100 text-start d-flex align-items-center justify-content-between form-control bg-white border"
                id="dropdown-channel-select"
                disabled={isSearchingByCartId}
              >
                <span className="text-truncate">
                  {channelId
                    ? channels.find(
                        (ch) => String(ch.id) === String(channelId),
                      )?.name || "Tất cả"
                    : "Tất cả"}
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu
                className="w-100 p-2 shadow-sm"
                style={{ maxHeight: "300px", overflowY: "auto" }}
              >
                <div className="px-1 mb-2 sticky-top bg-white">
                  <InputGroup>
                    <InputGroup.Text className="bg-white border-end-0">
                      <FontAwesomeIcon
                        icon={faSearch}
                        className="text-muted"
                      />
                    </InputGroup.Text>
                    <Form.Control
                      autoFocus
                      placeholder="Tìm đài..."
                      value={channelSearch}
                      onChange={(e) => setChannelSearch(e.target.value)}
                      className="bg-white border-start-0 ps-0"
                      onClick={(e) => e.stopPropagation()}
                    />
                  </InputGroup>
                </div>

                <Dropdown.Item
                  active={channelId === ""}
                  onClick={() => {
                    setChannelId("");
                    setChannelSearch("");
                  }}
                  className="rounded-2"
                >
                  Tất cả
                </Dropdown.Item>

                {filteredChannels.length > 0 ? (
                  filteredChannels.map((channel) => (
                    <Dropdown.Item
                      key={channel.id}
                      active={String(channelId) === String(channel.id)}
                      onClick={() => {
                        setChannelId(channel.id);
                        setChannelSearch("");
                      }}
                      className="rounded-2"
                    >
                      {channel.name}
                    </Dropdown.Item>
                  ))
                ) : (
                  <div className="text-center text-muted small py-2">
                    Không tìm thấy đài
                  </div>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>

        <Row className="g-3 align-items-end mt-1">
          <Col xs={12} md={6} xl={2}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Từ ngày</Form.Label>
            <Datetime
              timeFormat={false}
              dateFormat="DD/MM/YYYY"
              value={fromDate}
              onChange={(value) => setFromDate(value)}
              renderInput={(props, openCalendar) => (
                <InputGroup className="input-group-merge">
                  <InputGroup.Text className="bg-white border-end-0">
                    <FontAwesomeIcon icon={faCalendarAlt} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    className="border-start-0 ps-0"
                    value={
                      fromDate
                        ? moment(fromDate).format("DD/MM/YYYY")
                        : ""
                    }
                    placeholder="Chọn ngày"
                    onFocus={openCalendar}
                    onChange={() => {}}
                    disabled={isSearchingByCartId}
                  />
                </InputGroup>
              )}
            />
          </Col>

          <Col xs={12} md={6} xl={2}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Đến ngày</Form.Label>
            <Datetime
              timeFormat={false}
              dateFormat="DD/MM/YYYY"
              value={toDate}
              onChange={(value) => setToDate(value)}
              renderInput={(props, openCalendar) => (
                <InputGroup className="input-group-merge">
                  <InputGroup.Text className="bg-white border-end-0">
                    <FontAwesomeIcon icon={faCalendarAlt} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    className="border-start-0 ps-0"
                    value={toDate ? moment(toDate).format("DD/MM/YYYY") : ""}
                    placeholder="Chọn ngày"
                    onFocus={openCalendar}
                    onChange={() => {}}
                    disabled={isSearchingByCartId}
                  />
                </InputGroup>
              )}
            />
          </Col>

          <Col xs={12} md={6} xl={2}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">SĐT người chơi</Form.Label>
            <Form.Control
              type="text"
              placeholder="Nhập SĐT"
              value={playerPhone}
              onChange={(e) => setPlayerPhone(e.target.value)}
              onKeyPress={handleKeyPress}
              className="bg-white"
              disabled={isSearchingByCartId}
            />
          </Col>

          <Col xs={12} md={6} xl={2}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Tên người chơi</Form.Label>
            <Form.Control
              type="text"
              placeholder="Nhập tên"
              value={playerName}
              onChange={(e) => setPlayerName(e.target.value)}
              onKeyPress={handleKeyPress}
              className="bg-white"
              disabled={isSearchingByCartId}
            />
          </Col>

          <Col xs={12} md={6} xl={2}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">&nbsp;</Form.Label>
            <div className="d-flex gap-2">
              <Button
                variant="outline-secondary"
                onClick={_resetForm}
                className="flex-grow-1"
              >
                <FontAwesomeIcon icon={faEraser} className="me-1" />
                Xóa
              </Button>
              <Button
                variant="primary"
                onClick={_submitForm}
                disabled={state.loading}
                className="flex-grow-1"
              >
                {state.loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-1" />
                    Đang tìm...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faSearch} className="me-1" />
                    Tìm
                  </>
                )}
              </Button>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default React.memo(_FilterForm);
